import {postFormData} from './utils';
import _isObject from 'lodash/isObject';

const dao = {
  createRequest: async (request, files) => {
    const data = new FormData();
    const fields = Object.keys(request);
    fields.forEach(field =>
      data.append(
        `support.${field}`,
        _isObject(request[field])
          ? JSON.stringify(request[field])
          : request[field]
      )
    );
    let fileIdx = 0;
    files &&
      files.forEach(file => file && data.append(`files[${fileIdx++}]`, file));
    return await postFormData(
      '/smb-backend/support/create-request.action',
      data
    );
  },
};

export default dao;
